import { createApiSlice } from "@common";
import {
  CRUD_CAMPAIGN_TARGET_METRIC,
  GET_CAMPAIGN_TARGET_METRIC_BY_CAMPAIGN_ID
} from "@routes";

// 1 to 1
const apiConfig = [
  {
    name: "addCampaignTargetMetric",
    method: "post",
    url: CRUD_CAMPAIGN_TARGET_METRIC,
    stateKey: "message",
  },
  {
    name: "getCampaignTargetMetricByCampaignId",
    method: "get",
    url: GET_CAMPAIGN_TARGET_METRIC_BY_CAMPAIGN_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "campaignTargetMetric",
  apiConfig,
  customReducers,
);
const campaignTargetMetricSlice = slice;

export default campaignTargetMetricSlice.reducer;

export const {
  addCampaignTargetMetric,
  getCampaignTargetMetricByCampaignId,
} = thunks;

export const { rowSelect } = actions;
